import React, { useEffect, useState, useCallback, useRef } from 'react';
import axios from 'axios';
import { API } from '../config';
import { tr } from '../til';


const inputStyle = {
  padding: '10px 12px',
  border: '1px solid #ddd',
  borderRadius: '8px',
  fontSize: '14px'
};

const smallBtn = {
  padding: '6px 12px',
  background: '#eef1f7',
  color: '#1a1a2e',
  border: '1px solid #ddd',
  borderRadius: '8px',
  fontSize: '12px',
  cursor: 'pointer'
};

const CATEGORIES = [
  { value: 'yangilik', label: tr("Yangilik") },
  { value: 'elon', label: tr("E'lon") },
  { value: 'tadbir', label: tr("Tadbir") },
  { value: 'buyruq', label: tr("Buyruq") }
];

const categoryLabel = (value) =>
  CATEGORIES.find(c => c.value === value)?.label || value;

const emptyForm = () => ({
  title: '', category: 'yangilik', type: 'text', url: '', content: ''
});

// Havola o'zimizning serverga yuklangan faylgami?
const isUploaded = (url) => /\/uploads\/videos\//.test(url || '');

// Yangilik formasi — qo'shishda ham, tahrirlashda ham ishlatiladi.
// onUploading — video yuklanayotganini ota komponentga bildiradi, u
// "Joylash" tugmasini shu vaqtda bloklab turadi.
function NewsForm({ form, setForm, onUploading }) {
  const set = (field, value) => setForm({ ...form, [field]: value });

  const [progress, setProgress] = useState(null);
  const [uploadError, setUploadError] = useState('');
  const fileInput = useRef(null);

  const uploadVideo = async (file) => {
    if (!file) return;

    setUploadError('');
    setProgress(0);
    onUploading?.(true);

    const data = new FormData();
    data.append('video', file);

    try {
      const res = await axios.post(`${API}/news/upload-video`, data, {
        headers: { authorization: localStorage.getItem('token') },
        onUploadProgress: e =>
          setProgress(e.total ? Math.round((e.loaded * 100) / e.total) : 0)
      });
      // Havola avtomatik qo'yiladi. Yuklash uzoq davom etgani uchun shu
      // orada sarlavha o'zgargan bo'lishi mumkin — eng so'nggi holatni olamiz.
      setForm(prev => ({ ...prev, url: res.data.url }));
    } catch (err) {
      setUploadError(err.response?.data?.error || tr("Video yuklanmadi. Qayta urinib ko'ring."));
    } finally {
      setProgress(null);
      onUploading?.(false);
      // Bir xil faylni qayta tanlash mumkin bo'lsin.
      if (fileInput.current) fileInput.current.value = '';
    }
  };

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
      <input
        type="text"
        placeholder={tr("Sarlavha *")}
        value={form.title}
        onChange={e => set('title', e.target.value)}
        style={{ ...inputStyle, gridColumn: '1 / -1' }}
      />

      <select value={form.category} onChange={e => set('category', e.target.value)} style={inputStyle}>
        {CATEGORIES.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
      </select>

      <select value={form.type} onChange={e => set('type', e.target.value)} style={inputStyle}>
        <option value="text">{tr("Turi: Matn")}</option>
        <option value="video">{tr("Turi: Video")}</option>
      </select>

      {form.type === 'video' && (
        <>
          <div style={{
            gridColumn: '1 / -1',
            border: '1px dashed #ccd',
            borderRadius: '8px',
            padding: '14px',
            background: '#fafbff'
          }}>
            <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', marginBottom: '8px' }}>
              {tr("Kompyuterdan video yuklash")}
            </label>

            <input
              ref={fileInput}
              type="file"
              accept="video/*"
              disabled={progress !== null}
              onChange={e => uploadVideo(e.target.files[0])}
              style={{ fontSize: '13px' }}
            />

            {progress !== null && (
              <div style={{ marginTop: '10px' }}>
                <div style={{ height: '6px', background: '#e6e8f0', borderRadius: '3px', overflow: 'hidden' }}>
                  <div style={{
                    width: `${progress}%`,
                    height: '100%',
                    background: '#4f8ef7',
                    transition: 'width .2s'
                  }} />
                </div>
                <p style={{ margin: '6px 0 0', fontSize: '12px', color: '#666' }}>
                  {progress < 100
                    ? tr("Yuklanmoqda... {progress}%", { progress })
                    : tr("Server faylni qabul qilmoqda...")}
                </p>
              </div>
            )}

            {uploadError && (
              <p style={{ margin: '8px 0 0', fontSize: '12px', color: '#c93636' }}>{uploadError}</p>
            )}

            {progress === null && !uploadError && (
              <p style={{ margin: '8px 0 0', fontSize: '12px', color: '#999' }}>
                {tr("Fayl yuklangach havola quyida o'zi paydo bo'ladi. Eng ko'pi 500 MB (mp4, mov, webm, mkv, avi).")}
              </p>
            )}
          </div>

          <input
            type="text"
            placeholder={tr("Video havolasi * (yuklasangiz o'zi to'ladi, yoki YouTube havolasi)")}
            value={form.url}
            onChange={e => set('url', e.target.value)}
            style={{ ...inputStyle, gridColumn: '1 / -1' }}
          />

          {isUploaded(form.url) ? (
            <video
              src={form.url}
              controls
              preload="metadata"
              style={{ gridColumn: '1 / -1', width: '100%', maxHeight: '260px', borderRadius: '8px', background: '#000' }}
            />
          ) : (
            <p style={{ gridColumn: '1 / -1', margin: 0, color: '#999', fontSize: '12px' }}>
              {tr("Yoki tashqi havola: https://www.youtube.com/watch?v=...")}
            </p>
          )}
        </>
      )}

      <textarea
        placeholder={form.type === 'video' ? tr("Video tavsifi (ixtiyoriy)") : tr("Yangilik matni *")}
        value={form.content}
        onChange={e => set('content', e.target.value)}
        rows={form.type === 'video' ? 3 : 7}
        style={{ ...inputStyle, gridColumn: '1 / -1', resize: 'vertical', fontFamily: 'inherit' }}
      />
    </div>
  );
}

function News() {
  const [news, setNews] = useState([]);
  const [form, setForm] = useState(emptyForm());
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(false);

  const [editing, setEditing] = useState(null);
  const [editError, setEditError] = useState('');
  const [editSaving, setEditSaving] = useState(false);
  const [editUploading, setEditUploading] = useState(false);

  const token = localStorage.getItem('token');

  const loadNews = useCallback(() => {
    axios.get(`${API}/news`, { headers: { authorization: token } })
      .then(res => setNews(res.data));
  }, [token]);

  useEffect(() => {
    loadNews();
  }, [loadNews]);

  // Server ham tekshiradi, lekin xatoni darhol ko'rsatgan yaxshi.
  const validate = (f) => {
    if (!f.title.trim()) return tr("Sarlavha kiriting");
    if (f.type === 'video' && !f.url.trim()) return tr("Video uchun havola kiriting");
    if (f.type === 'text' && !f.content.trim()) return tr("Yangilik matnini kiriting");
    return null;
  };

  const createNews = async () => {
    setError('');
    setSuccess('');

    const invalid = validate(form);
    if (invalid) { setError(invalid); return; }

    setSaving(true);
    try {
      await axios.post(`${API}/news/create`, form, { headers: { authorization: token } });
      setSuccess(tr("\"{title}\" qo'shildi.", { title: form.title }));
      setForm(emptyForm());
      loadNews();
    } catch (err) {
      setError(err.response?.data?.error || tr("Yangilik qo'shilmadi."));
    } finally {
      setSaving(false);
    }
  };

  const saveEdit = async () => {
    setEditError('');

    const invalid = validate(editing);
    if (invalid) { setEditError(invalid); return; }

    setEditSaving(true);
    try {
      await axios.put(`${API}/news/${editing.id}`, {
        title: editing.title,
        category: editing.category,
        type: editing.type,
        url: editing.url,
        content: editing.content
      }, { headers: { authorization: token } });

      setSuccess(tr("\"{title}\" yangilandi.", { title: editing.title }));
      setEditing(null);
      loadNews();
    } catch (err) {
      setEditError(err.response?.data?.error || tr("Saqlanmadi."));
    } finally {
      setEditSaving(false);
    }
  };

  const deleteNews = async (item) => {
    setError('');
    setSuccess('');
    if (!window.confirm(tr("\"{title}\" o'chirilsinmi?\n\nBu amalni qaytarib bo'lmaydi.", { title: item.title }))) return;

    try {
      await axios.delete(`${API}/news/${item.id}`, { headers: { authorization: token } });
      setSuccess(tr("\"{title}\" o'chirildi.", { title: item.title }));
      loadNews();
    } catch (err) {
      setError(err.response?.data?.error || tr("O'chirib bo'lmadi."));
    }
  };

  return (
    <div>
      <h2 style={{ marginBottom: '24px', fontSize: '22px' }}>{tr("Yangiliklar")}</h2>

      <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', boxShadow: '0 1px 8px rgba(0,0,0,0.06)', marginBottom: '24px' }}>
        <h3 style={{ marginBottom: '16px', fontSize: '16px' }}>{tr("Yangi yangilik")}</h3>

        <NewsForm form={form} setForm={setForm} onUploading={setUploading} />

        {error && (
          <div style={{ background: '#ffeaea', color: '#c93636', padding: '10px 12px', borderRadius: '8px', fontSize: '13px', margin: '12px 0' }}>
            {error}
          </div>
        )}
        {success && (
          <div style={{ background: '#e9f9ed', color: '#2d8a2d', padding: '10px 12px', borderRadius: '8px', fontSize: '13px', margin: '12px 0' }}>
            {success}
          </div>
        )}

        <button
          onClick={createNews}
          disabled={saving || uploading}
          style={{
            marginTop: '12px',
            padding: '10px 24px',
            background: (saving || uploading) ? '#888' : '#1a1a2e',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            fontSize: '14px',
            width: '100%',
            cursor: (saving || uploading) ? 'default' : 'pointer'
          }}
        >
          {uploading ? tr("Video yuklanmoqda...") : saving ? tr("Qo'shilmoqda...") : tr("Joylash")}
        </button>
      </div>

      <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', boxShadow: '0 1px 8px rgba(0,0,0,0.06)' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
              <th style={{ textAlign: 'left', padding: '10px 8px', color: '#888', fontWeight: '500' }}>{tr("Sarlavha")}</th>
              <th style={{ textAlign: 'left', padding: '10px 8px', color: '#888', fontWeight: '500' }}>{tr("Kategoriya")}</th>
              <th style={{ textAlign: 'left', padding: '10px 8px', color: '#888', fontWeight: '500' }}>{tr("Turi")}</th>
              <th style={{ textAlign: 'left', padding: '10px 8px', color: '#888', fontWeight: '500' }}>{tr("Sana")}</th>
              <th style={{ textAlign: 'right', padding: '10px 8px', color: '#888', fontWeight: '500' }}>{tr("Amallar")}</th>
            </tr>
          </thead>
          <tbody>
            {news.map(item => (
              <tr key={item.id} style={{ borderBottom: '1px solid #f9f9f9' }}>
                <td style={{ padding: '10px 8px', fontWeight: '500', maxWidth: '340px' }}>
                  {item.title}
                  {item.type === 'video' && item.url && (
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noreferrer"
                      style={{ marginLeft: '8px', color: '#4f8ef7', fontSize: '12px', fontWeight: '400' }}
                    >
                      {tr("havola ↗")}
                    </a>
                  )}
                </td>
                <td style={{ padding: '10px 8px' }}>
                  <span style={{ background: '#e6f0ff', color: '#4f8ef7', padding: '3px 10px', borderRadius: '20px', fontSize: '12px' }}>
                    {categoryLabel(item.category)}
                  </span>
                </td>
                <td style={{ padding: '10px 8px' }}>
                  <span style={{
                    background: item.type === 'video' ? '#fff0e6' : '#f0f0f5',
                    color: item.type === 'video' ? '#f7924f' : '#666',
                    padding: '3px 10px',
                    borderRadius: '20px',
                    fontSize: '12px'
                  }}>
                    {item.type === 'video' ? tr("▶ Video") : tr("📄 Matn")}
                  </span>
                </td>
                <td style={{ padding: '10px 8px', color: '#888' }}>
                  {new Date(item.created_at).toLocaleDateString('uz-UZ')}
                </td>
                <td style={{ padding: '10px 8px', textAlign: 'right', whiteSpace: 'nowrap' }}>
                  <button
                    onClick={() => { setEditError(''); setEditing({ ...item, url: item.url || '', content: item.content || '' }); }}
                    style={{ ...smallBtn, marginRight: '6px' }}
                  >
                    {tr("Tahrirlash")}
                  </button>
                  <button onClick={() => deleteNews(item)} style={{ ...smallBtn, color: '#c93636' }}>
                    {tr("O'chirish")}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {news.length === 0 && (
          <p style={{ color: '#999', fontSize: '14px', textAlign: 'center', margin: '20px 0 0' }}>
            {tr("Hali yangilik joylanmagan.")}
          </p>
        )}
      </div>

      {editing && (
        <div
          onClick={() => setEditing(null)}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', zIndex: 100
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              background: '#fff', borderRadius: '12px', padding: '24px',
              width: '100%', maxWidth: '620px', maxHeight: '88vh', overflowY: 'auto'
            }}
          >
            <h3 style={{ marginTop: 0, marginBottom: '16px', fontSize: '18px' }}>{tr("Yangilikni tahrirlash")}</h3>

            <NewsForm form={editing} setForm={setEditing} onUploading={setEditUploading} />

            {editError && (
              <div style={{ background: '#ffeaea', color: '#c93636', padding: '10px 12px', borderRadius: '8px', fontSize: '13px', margin: '12px 0' }}>
                {editError}
              </div>
            )}

            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px' }}>
              <button onClick={() => setEditing(null)} style={{ ...smallBtn, padding: '10px 20px', fontSize: '14px' }}>
                {tr("Bekor qilish")}
              </button>
              <button
                onClick={saveEdit}
                disabled={editSaving || editUploading}
                style={{
                  padding: '10px 24px',
                  background: (editSaving || editUploading) ? '#888' : '#1a1a2e',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '14px',
                  cursor: (editSaving || editUploading) ? 'default' : 'pointer'
                }}
              >
                {editUploading ? tr("Video yuklanmoqda...") : editSaving ? tr("Saqlanmoqda...") : tr("Saqlash")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default News;
